module.exports = __webpack_public_path__ + "static/media/about5.5c14a58c.jpg";